<template>
  <div id="ArticleTopBanner">
    <img :src="require('../assets/aboutme_top_img.jpg')">
  </div>
</template>

<script>
export default {
  name: "ArticleTopBanner"
}
</script>


<style lang="less" scoped>
@fullWidth:11.25rem;
.fullWidth{
  width: @fullWidth;
}

#ArticleTopBanner{
  .fullWidth();

  img{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleTopBanner_aboutus.vue